"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var DiscourseRenderer_1 = __importStar(require("./DiscourseRenderer"));
var tabletUtils_1 = require("./tabletUtils");
var DiscourseHtmlRenderer = (function (_super) {
    __extends(DiscourseHtmlRenderer, _super);
    function DiscourseHtmlRenderer(discourseUnits, locale) {
        var _this = _super.call(this, discourseUnits, locale) || this;
        _this.renderClass = DiscourseHtmlRenderer;
        return _this;
    }
    DiscourseHtmlRenderer.prototype.wordsOnLine = function (line) {
        var _this = this;
        var words = [];
        (0, DiscourseRenderer_1.displayUnitHelper)(this.discourseUnits, line, words, {
            transliteration: function (word) { return "<em>".concat(word, "</em>"); },
            spelling: determinativeFormatter,
        });
        return words.map(function (word) { return (__assign(__assign({}, word), { display: (0, tabletUtils_1.localizeString)(word.display, _this.locale) })); });
    };
    DiscourseHtmlRenderer.prototype.lineReading = function (line) {
        var _this = this;
        var words = [];
        (0, DiscourseRenderer_1.displayUnitHelper)(this.discourseUnits, line, words, {
            transliteration: function (word) { return "<em>".concat(word, "</em>"); },
            spelling: determinativeFormatter,
        });
        return words
            .map(function (word) { return (0, tabletUtils_1.localizeString)(word.display, _this.locale); })
            .join(' ');
    };
    DiscourseHtmlRenderer.prototype.lineReadingForWordsInTexts = function (line, discourseUuids) {
        var _this = this;
        var words = [];
        (0, DiscourseRenderer_1.lineReadingHelperForWordsInTexts)(this.discourseUnits, discourseUuids, line, words, {
            transliteration: function (word) { return "<em>".concat(word, "</em>"); },
            spelling: determinativeFormatter,
        });
        return words.map(function (word) { return (0, tabletUtils_1.localizeString)(word, _this.locale); }).join(' ');
    };
    return DiscourseHtmlRenderer;
}(DiscourseRenderer_1.default));
exports.default = DiscourseHtmlRenderer;
function determinativeFormatter(word) {
    var matches = word.match(/\(.+\)/) || [];
    matches.forEach(function (match) {
        word = word.replace(match, "<sup>".concat(match.slice(1, match.length - 1), "</sup>"));
    });
    return word;
}
//# sourceMappingURL=DiscourseHtmlRenderer.js.map